// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"834f8131c4fd70de","1836":"9f69f0f3d1b6ca6c","5735":"beb578cc985d134d"}[chunkId] + ".css";
};